var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnableGridWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.211,3h9.579A2.208,2.208,0,0,1,16,5.211v9.579A2.208,2.208,0,0,1,13.789,17H4.211A2.208,2.208,0,0,1,2,14.789V5.211A2.208,2.208,0,0,1,4.211,3m0,.737A1.478,1.478,0,0,0,2.737,5.211V7.421H6.421V3.737H4.211M2.737,14.789a1.478,1.478,0,0,0,1.474,1.474H6.421V12.579H2.737v2.211M6.421,8.158H2.737v3.684H6.421V8.158m7.368,8.105a1.478,1.478,0,0,0,1.474-1.474V12.579H11.579v3.684h2.211m1.474-8.105H11.579v3.684h3.684V8.158m0-2.947a1.478,1.478,0,0,0-1.474-1.474H11.579V7.421h3.684V5.211M7.158,3.737V7.421h3.684V3.737H7.158m0,12.526h3.684V12.579H7.158v3.684m3.684-8.105H7.158v3.684h3.684Z",
    transform: "translate(-2 -3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnableGridWhite);
export default __webpack_public_path__ + "static/media/enable-grid-white.d37cfa2907c7efe570fc75ecba14f201.svg";
export { ForwardRef as ReactComponent };